/* ==============================================================
   F-258 (2026-05-14): Move footer social icons → newsletter column

   Boss request: "ย้ายไปอยู่ช่องกรอกอีเมล์" (move social to email input column)

   Halo theme architecture: social icons live in .hdt-social-media column
   (sibling to .hdt-footer-newsletter). CSS alone cannot move across columns,
   so this script relocates the social UL via DOM manipulation on page load.

   Target placement: AFTER input/button inside newsletter collapse content,
   matching Casper-style "newsletter form + social engagement" pattern.
   ============================================================== */
(function () {
  'use strict';

  function moveFooterSocial() {
    var footer = document.querySelector('footer, [class*="hdt-footer"]');
    if (!footer) return false;

    var socialList = footer.querySelector('.hdt-socials__list');
    var newsletterCol = footer.querySelector('.hdt-footer-newsletter');
    if (!socialList || !newsletterCol) return false;

    var collapseContent = newsletterCol.querySelector('.hdt-collapse-content');
    if (!collapseContent) return false;

    // Already moved? skip
    if (socialList.parentElement === collapseContent) return true;

    // Find the inner .hdt-footer-newsletter (input + button wrapper)
    var innerNewsletter = null;
    var children = collapseContent.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains('hdt-footer-newsletter')) {
        innerNewsletter = children[i];
        break;
      }
    }

    if (innerNewsletter) {
      // Insert AFTER inner newsletter (input/button)
      if (innerNewsletter.nextSibling) {
        collapseContent.insertBefore(socialList, innerNewsletter.nextSibling);
      } else {
        collapseContent.appendChild(socialList);
      }
    } else {
      collapseContent.appendChild(socialList);
    }

    // Tag the moved list so CSS can target it specifically
    socialList.classList.add('sh-footer-social-moved');
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFooterSocial);
  } else {
    moveFooterSocial();
  }
})();
